// extracted by mini-css-extract-plugin
export default {"root":"C07xQ__root"};